import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {ActivatedRoute, Router} from "@angular/router";
import {
  ApplicationDocumentResource,
  ApplicationResource,
  ApplicationsService
} from "../../core/modules/openapi";
import {MatDialog} from "@angular/material/dialog";
import {
  ApplicationDocumentDialogData,
  ApplicationDocumentUploadComponent
} from "../application-document-upload/application-document-upload.component";
import {MatCardModule} from "@angular/material/card";
import {NgIf} from "@angular/common";
import {ApplicationOutlineComponent} from "../application-outline/application-outline.component";
import {HttpResponse} from "@angular/common/http";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-application-documents',
  imports: [MatTableModule, MatPaginatorModule, MatIconModule, MatMenuModule, MatButtonModule, MatCardModule, NgIf, ApplicationOutlineComponent, MatProgressSpinner],
  templateUrl: './application-documents.component.html',
  standalone: true,
  styleUrl: './application-documents.component.sass'
})
export class ApplicationDocumentsComponent implements OnInit {
  protected roles: string[];

  constructor(private readonly route: ActivatedRoute,
              protected readonly router: Router,
              private readonly applicationsService: ApplicationsService,
              private readonly dialog: MatDialog) {
    let userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      this.roles = JSON.parse(userDetails).claims.realm_access.roles as string[];
    }
  }

  displayedColumns: string[] = ['documentType', 'description', 'status', 'actions'];
  dataSource: MatTableDataSource<ApplicationDocumentResource>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  applicationId: string;
  applicationResource: ApplicationResource;

  ngOnInit(): void {
    this.applicationId = this.route.snapshot.paramMap.get('id')!;
    this.applicationsService.getApplicationDocuments(this.applicationId).subscribe(response => {
      this.dataSource = new MatTableDataSource<ApplicationDocumentResource>(response);
      this.dataSource.paginator = this.paginator;
    });
    this.applicationsService.getApplicationById(this.applicationId).subscribe(response => {
      this.applicationResource = response;
    });
  }

  public uploadFile() {
    const dialogRef = this.dialog.open(ApplicationDocumentUploadComponent, {
      width: '30%',
      data: {
        applicationId: this.applicationId,
        documentTypes: this.dataSource.data.map(doc => doc.documentType),
      },
    });

    dialogRef.afterClosed().subscribe((result: ApplicationDocumentDialogData) => {
      this.applicationsService.getApplicationDocuments(this.applicationId).subscribe(response => {
        this.dataSource = new MatTableDataSource<ApplicationDocumentResource>(response);
        this.dataSource.paginator = this.paginator;
      });
    });
  }

  protected downloadFile(id: string) {
    this.applicationsService.downloadDocument(id, undefined, 'response').subscribe((response: HttpResponse<Blob>) => {
      const blob: Blob = response.body as Blob;
      // try to extract filename from headers if present
      let filename = 'document';
      if (response?.headers) {
        const contentDisposition = response.headers.get('content-disposition') || response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const match = /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i.exec(contentDisposition);
          if (match?.[1]) {
            try {
              filename = decodeURIComponent(match[1]);
            } catch {
              filename = match[1];
            }
          }
        }
      }
      const url = globalThis.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      globalThis.URL.revokeObjectURL(url);
    }, error => {
      console.error('Download failed', error);
    });

  }
}
